
import { defineComponent, PropType } from "vue";
import common from "@/config/common";
import helper from "@/utils/helper";
import routesPath from "@/config/routesPath";
import messages from "@/config/messages";
import * as apiClient from "@/apiclient/";
import { mapGetters } from "vuex";
import ConfirmationOpenEnrollmentBenefit from "./ConfirmationOpenEnrollmentBenefit.vue";
import ConfirmationCOBRAEnrollmentBenefit from "./ConfirmationCOBRAEnrollmentBenefit.vue";
import iCOBRABenefit from "@/types/iCOBRABenefit";

export default defineComponent({
  components: {
    ConfirmationOpenEnrollmentBenefit,
    ConfirmationCOBRAEnrollmentBenefit,
  },
  data() {
    return {
      common,
      dependentsPaginate: false,
      benefitsPaginate: false,
      paymentsPaginate: false,
      documentsPaginate: false,
      helper,
      allBenefitsWaived: false,
      convenienceFee: 0,
      selectedGender: "",
      validationMsg: "",
      messages,
      isStripeEnabled: false,
      mappedBenefits: null,
    };
  },
  props: {
    profileData: {
      type: Object as () => apiClient.ProfileResponseDto,
      default: {} as apiClient.ProfileResponseDto,
    },
    qualifyingBeneficiaryData: {
      type: Object as () => apiClient.QualifyingBeneficiaryDto,
      default: {} as apiClient.QualifyingBeneficiaryDto,
    },
    getStateName: String,
    getCountryName: String,
    dependentData: {
      type: Array as () => apiClient.GetAllDependentDto[],
      default: [] as apiClient.GetAllDependentDto[],
    },
    benefitsData: {
      type: Array as () => iCOBRABenefit[],
      default: [] as iCOBRABenefit[],
    },
    getMonthlyCountryName: String,
    monthlyPremiumData: {
      type: Object as () => apiClient.GetMonthlyPremiumDto,
      default: {} as apiClient.GetMonthlyPremiumDto,
    },
    getMonthlyStateName: String,
    amountTodayData: {
      type: Object as () => apiClient.GetAmountDueTodayDto,
      default: {} as apiClient.GetAmountDueTodayDto,
    },
    documentsData: {
      type: Array as () => apiClient.FileResponse[],
      default: [] as apiClient.FileResponse[],
    },
    genderOptions: {
      type: Object as () => apiClient.GenderDto[],
    },
    modifyBtn: {
      type: Boolean,
      default: true,
    },
    dataLoaded: {
      type: Boolean,
      default: false,
    },
    countries: { type: Object as any },
    paymentMethods: { type: Object as any },
    accountTypes: { type: Object as any },
    isPaymentEnabled: { type: Boolean, default: false },
    enrollmentType: {
      type: Number,
      default: 0,
    },
    openEnrollmentUnbundledBenefits: {
      type: Array as () => apiClient.OpenEnrollmentBenefitDto[],
      default: [] as apiClient.OpenEnrollmentBenefitDto[],
    },
    openEnrollmentBundles: {
      type: Array as () => apiClient.OpenEnrollmentBenefitsBundleDto[],
      default: [] as apiClient.OpenEnrollmentBenefitsBundleDto[],
    },
    cardDetail: {
      type: Object as () => apiClient.CardDetail,
      default: {} as apiClient.CardDetail,
    },
  },
  watch: {
    async profileData(value) {
      this.$nextTick(() => {
        const logoHeight = 75;
        const verticalMargin = 16;
        let profileHeight =
          (this.$refs.profileTable as any).offsetHeight + verticalMargin;
        let qualifyingBeneficiaryHeight = 0;
        if (this.$refs.qualifyingBeneficiaryTable) {
          qualifyingBeneficiaryHeight =
            (this.$refs.qualifyingBeneficiaryTable as any).offsetHeight +
            verticalMargin;
        }
        let dependentsHeight =
          (this.$refs.dependentsTable as any).offsetHeight + verticalMargin;
        let benefitsHeight =
          (this.$refs.benefitsTable as any).offsetHeight + verticalMargin;
        let paymentsHeight = 0;
        if (this.$refs.paymentsTable) {
          paymentsHeight =
            (this.$refs.paymentsTable as any).offsetHeight + verticalMargin;
        }
        let documentsHeight = 0;
        if (this.$refs.documentsTable) {
          documentsHeight =
            (this.$refs.documentsTable as any).offsetHeight + verticalMargin;
        }
        if (
          logoHeight +
            profileHeight +
            qualifyingBeneficiaryHeight +
            dependentsHeight +
            benefitsHeight >
          1000
        ) {
          this.dependentsPaginate = true;
          profileHeight = 0;
          qualifyingBeneficiaryHeight = 0;
          dependentsHeight = 0;
        }
        if (
          logoHeight +
            profileHeight +
            qualifyingBeneficiaryHeight +
            dependentsHeight +
            benefitsHeight >
          900
        ) {
          this.benefitsPaginate = true;
          profileHeight = 0;
          qualifyingBeneficiaryHeight = 0;
          dependentsHeight = 0;
          benefitsHeight = 0;
        }
        if (
          logoHeight +
            profileHeight +
            qualifyingBeneficiaryHeight +
            dependentsHeight +
            benefitsHeight +
            paymentsHeight >
          1050
        ) {
          this.benefitsPaginate = true;
          profileHeight = 0;
          qualifyingBeneficiaryHeight = 0;
          dependentsHeight = 0;
          benefitsHeight = 0;
        }
        if (
          logoHeight +
            profileHeight +
            qualifyingBeneficiaryHeight +
            dependentsHeight +
            benefitsHeight +
            paymentsHeight +
            documentsHeight >
          1000
        ) {
          this.paymentsPaginate = true;
        }
      });
    },
  },
  created() {
    if (
      sessionStorage.getItem(common.storageVariables.allBenefitsWaived) ===
      "true"
    )
      this.allBenefitsWaived = true;

    if (this.getEnrollment.serviceType == 0) {
      this.getConvenienceFee();
    }
    this.getStripeEnabled();
  },
  computed: {
    calculateAmountDue() {
      let total = 0;
      this.benefitsData.forEach((benefit) => {
        if (benefit.isWaived === false) {
          total += benefit.initialAmount!;
        }
      });
      if (this.amountTodayData?.payMethod === this.common.paymentMethods.Card) {
        total = total + this.convenienceFee;
      }
      return helper.formatNumber(total);
    },
    calculateMonthlyPremium() {
      let total = 0;
      this.benefitsData.forEach((benefit) => {
        if (benefit.isWaived === false) {
          if (benefit.benefitRateTypeId === common.benefit.tier) {
            const coverageOption = benefit.coverageOptions!.find(
              (option) => option.isSelected
            );
            if (coverageOption) {
              total += coverageOption.monthlyPremiumRate!;
            }
          } else if (benefit.benefitRateTypeId === common.benefit.single) {
            total += benefit.singleMonthlyPremiumRate!;
          } else if (benefit.benefitRateTypeId === common.benefit.unique) {
            total += benefit.uniqueMonthlyPremiumRate ?? 0;
          }
        }
      });
      return helper.formatNumber(total);
    },
    ...mapGetters(["getFormDirty", "getEnrollment"]),
  },
  methods: {
    formatAddress(address1?: string, address2?: string) {
      let address = "";
      if (address1) {
        address = address1;
      }
      if (address2) {
        address += "<br/>";
        address += address2;
      }
      return address;
    },
    formatBytes(bytes: number, decimals = 2): string {
      if (bytes === 0) return "0B";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + "" + sizes[i];
    },
    getExtIcon(fileType: string) {
      const allFileTypes: { [key: string]: { icon: string } } = {
        "image/tiff": { icon: "tiff-icon.svg" },
        "image/bmp": { icon: "bmp-icon.svg" },
        "image/png": { icon: "png-icon.svg" },
        "image/jpeg": { icon: "jpeg-icon.svg" },
        "application/pdf": { icon: "pdf-icon.svg" },
      };

      return allFileTypes[fileType]?.icon ?? "pdf-icon.svg";
    },
    getAccountType(accountType: string) {
      return accountType === this.accountTypes.Check ? "Checking" : "Savings";
    },
    formatDate(date: string): string {
      if (!date) {
        return "";
      }
      return helper.formatDate(date);
    },
    getPaymentMethod(type: string, payMethod: number) {
      switch (payMethod) {
        case common.paymentMethods.ACH:
          return "Automatic (ACH)";
        case common.paymentMethods.Invoice:
          return type === "monthlyPremium" ? "Invoice" : "Check";
        case common.paymentMethods.Card:
          return this.isStripeEnabled ? "Credit/Debit Card" : "";
        default:
          return "";
      }
    },
    redirectProfilePage() {
      this.$router.push({
        path: routesPath.profileInformation,
      });
    },
    async redirectDependentPage() {
      this.$router.push({
        path: routesPath.dependents,
      });
    },
    async getConvenienceFee(): Promise<void> {
      const result = await apiClient.paymentController().getApiPayment({
        customerParticipantId: this.getEnrollment.customerParticipantId,
      });

      if (result.data) {
        this.convenienceFee = result.data.convenienceFee!;
      }
    },
    async getStripeEnabled() {
      let stripeData = await helper.getStripeEnabled();
      if (stripeData) {
        if (stripeData!.validationMsg.length > 0) {
          this.validationMsg = stripeData.validationMsg;
          this.isStripeEnabled = false;
        } else {
          this.isStripeEnabled = stripeData.isStripeEnabled!;
        }
      }
    },
    async redirectBnefitPage() {
      this.$router.push({
        path: routesPath.benefits,
      });
    },
    async redirectPaymentPage() {
      this.$router.push({
        path: routesPath.payments,
      });
    },
    async redirectDocumentsPage() {
      this.$router.push({
        path: routesPath.documents,
      });
    },
    getSubsidyAmount(benefit: iCOBRABenefit): number {
      if (benefit.benefitRateTypeId === common.benefit.tier) {
        var foundTiers = benefit.coverageOptions.filter(
          (option) => option.isSelected == true
        );

        if (foundTiers.length > 0) {
          return -1 * (foundTiers[0].subsidyTotal ?? 0);
        }

        return 0;
      }

      return -1 * benefit.subsidyTotal!;
    },
  },
});
